import { render } from "./slack-login-button.vue?vue&type=template&id=6947b2aa&scoped=true&ts=true"
import script from "./slack-login-button.vue?vue&type=script&lang=ts"
export * from "./slack-login-button.vue?vue&type=script&lang=ts"

import "./slack-login-button.vue?vue&type=style&index=0&id=6947b2aa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6947b2aa"]])

export default __exports__